import cloneDeep from 'lodash.clonedeep';
import canDeleteScenes from 'JS/shared/helpers/canDeleteScenes';

function deleteScenesAndElementsFromScribe(scribe, sceneIdsToDelete) {
  const updatedScribe = cloneDeep(scribe);
  updatedScribe.scenes = updatedScribe.scenes.filter(scene => !sceneIdsToDelete.includes(scene.id));

  const remainingElementIds = updatedScribe.scenes.flatMap(scene => scene.elementIds);
  updatedScribe.elements = updatedScribe.elements.filter(element => remainingElementIds.includes(element.id));

  return updatedScribe;
}

export default function deleteScenesFromScribe(scribe, sceneIdsToDelete) {
  if (!scribe || !sceneIdsToDelete || !sceneIdsToDelete.length) return scribe;

  const scribeHasScenesToBeDeleted = sceneIdsToDelete.some(
    sceneId => !!scribe.scenes.find(scene => scene.id === sceneId)
  );
  if (!scribeHasScenesToBeDeleted) return scribe;

  if (!canDeleteScenes(scribe, sceneIdsToDelete)) return scribe;

  const deletedScenesContainsActiveScene = sceneIdsToDelete.includes(scribe.scenes.find(scene => scene.active).id);
  if (!deletedScenesContainsActiveScene) {
    return deleteScenesAndElementsFromScribe(scribe, sceneIdsToDelete);
  }

  const activeSceneIsFirstScene = scribe.scenes.findIndex(scene => scene.active) === 0;
  if (activeSceneIsFirstScene) {
    const updatedScribe = deleteScenesAndElementsFromScribe(scribe, sceneIdsToDelete);
    updatedScribe.scenes[0].active = true;
    return updatedScribe;
  } else {
    let loopbackIndex = scribe.scenes.findIndex(scene => scene.active);
    let sceneIdToActivate;
    while (loopbackIndex > 0) {
      loopbackIndex -= 1;

      if (!sceneIdsToDelete.includes(scribe.scenes[loopbackIndex].id)) {
        sceneIdToActivate = scribe.scenes[loopbackIndex].id;
        break;
      }
    }

    const updatedScribe = deleteScenesAndElementsFromScribe(scribe, sceneIdsToDelete);
    if (!sceneIdToActivate) {
      updatedScribe.scenes[0].active = true;
    } else {
      updatedScribe.scenes.find(scene => scene.id === sceneIdToActivate).active = true;
    }

    return updatedScribe;
  }
}
